import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { Vinyl } from '../types';

export class VinylService {
  static async createVinyl(vinyl: Omit<Vinyl, 'id'>): Promise<Vinyl> {
    try {
      const vinylRef = doc(collection(db, 'vinyls'));

      const vinylData: any = {
        ...vinyl,
        createdAt: Timestamp.now(),
      };

      await setDoc(vinylRef, vinylData);

      return {
        ...vinyl,
        id: vinylRef.id,
      };
    } catch (error: any) {
      throw new Error(`Failed to create vinyl: ${error.message}`);
    }
  }

  static async getVinyl(id: string): Promise<Vinyl | null> {
    try {
      const docSnap = await getDoc(doc(db, 'vinyls', id));
      if (docSnap.exists()) {
        return { ...docSnap.data(), id: docSnap.id } as Vinyl;
      }
      return null;
    } catch (error: any) {
      throw new Error(`Failed to get vinyl: ${error.message}`);
    }
  }

  static async getAllVinyls(): Promise<Vinyl[]> {
    try {
      const q = query(collection(db, 'vinyls'), orderBy('order', 'asc'));
      const querySnap = await getDocs(q);
      return querySnap.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      } as Vinyl));
    } catch (error: any) {
      throw new Error(`Failed to get vinyls: ${error.message}`);
    }
  }

  static async updateVinyl(id: string, updates: Partial<Vinyl>): Promise<void> {
    try {
      const { id: _id, ...dataToUpdate } = updates as any;
      await updateDoc(doc(db, 'vinyls', id), {
        ...dataToUpdate,
        updatedAt: Timestamp.now(),
      });
    } catch (error: any) {
      throw new Error(`Failed to update vinyl: ${error.message}`);
    }
  }

  static async deleteVinyl(id: string): Promise<void> {
    try {
      await deleteDoc(doc(db, 'vinyls', id));
    } catch (error: any) {
      throw new Error(`Failed to delete vinyl: ${error.message}`);
    }
  }
}
